import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-71">
      {/* Background Orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-72">
        <div className="absolute top-[20%] right-[10%] w-[40vw] h-[40vw] rounded-full bg-[#7c5cfc]/20 blur-[120px] animate-drift" data-id="element-73" />
        <div className="absolute bottom-[10%] left-[20%] w-[35vw] h-[35vw] rounded-full bg-[#22d3ee]/20 blur-[100px] animate-drift" style={{
        animationDelay: '-5s'
      }} data-id="element-74" />
        <div className="absolute top-[40%] left-[40%] w-[30vw] h-[30vw] rounded-full bg-[#ff2d8a]/15 blur-[90px] animate-drift" style={{
        animationDelay: '-10s'
      }} data-id="element-75" />
      </div>

      <motion.div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center" style={{
      y,
      opacity
    }} data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-77">
          <span className="inline-block py-1 px-3 rounded-full bg-white/5 border border-white/10 text-sm font-medium text-[#22d3ee] mb-6" data-id="element-78">
            סטודיו לעיצוב ופיתוח אתרים
          </span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-black text-white leading-[1.1] tracking-tight mb-8" initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-79">
          אנחנו בונים חוויות <br className="hidden md:block" data-id="element-80" />
          דיגיטליות <span className="text-gradient" data-id="element-81">שלא שוכחים</span>
        </motion.h1>

        <motion.p className="text-lg md:text-2xl text-white/60 max-w-2xl mx-auto mb-12 font-light" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-82">
          מסטארטאפים ועד מותגי ענק, אנחנו הופכים רעיונות מורכבים למוצרים
          דיגיטליים מרהיבים, חכמים ומדויקים.
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-83">
          <a href="#work" className="w-full sm:w-auto px-8 py-4 bg-white text-[#0a0a0f] font-bold rounded-full hover:scale-105 transition-transform duration-300" data-id="element-84">
            צפו בעבודות שלנו
          </a>
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/20 text-white font-bold rounded-full hover:bg-white/5 hover:border-white/40 transition-all duration-300" data-id="element-85">
            התחילו פרויקט
          </a>
        </motion.div>
      </motion.div>

      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/30" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-86">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-87">
          <ArrowDown size={24} data-id="element-88" />
        </motion.div>
      </motion.div>
    </section>;
}